import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Template from "./template";

const dataQuery = graphql`
  query {
    homeJson {
      osfSection {
        text
        image {
          src {
            publicURL
          }
          alt
          link
        }
      }
    }
  }
`;

function OsfSection() {
  const {
    homeJson: { osfSection }
  } = useStaticQuery(dataQuery);

  return <Template data={osfSection} />;
}

export default OsfSection;
